import React from 'react';
import './ScreenExperimentWizard.scss';
import { CreateExpOptionsProps } from 'business/models/CustomModels';
import WizardContentParent from './WizardContentParent';

function CreateExpOptions({
  heading,
  style,
  children,
  selectedOption,
  setSelectedOption,
  options,
  placeholder,
  disableSelect = false,
}: CreateExpOptionsProps) {
  return (
    <WizardContentParent
      id={`createexpoptions-${heading}`}
      heading={heading}
      style={{ width: '40%' }}
    >
      {children}
      {}
    </WizardContentParent>
  );
}

export default CreateExpOptions;
